import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AOS from 'aos';

import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './landing.layout.css';

import Header from '../components/header.component';
import Footer from '../components/footer.component';
import ScrollHandler from '../components/scroll-handler.component';
import ChatWidget from 'components/chat-widget.component';
import { usePreloader } from '../hooks/preloader.hook';
import { useDynamicFont } from '../hooks/dynamic-font.hook';

function LandingLayout() {
  const loading = usePreloader();
  useDynamicFont("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      {loading && <div id="preloader" />}

      <Header />
      <section className="hero section dark-background">
        <img src="/assets/img/hero-bg-2.jpg" alt="" className="hero-bg" />
        <div className="container">
          <div className="row gy-4 justify-content-between">
            <div className="col-lg-4 order-lg-last hero-img" data-aos="zoom-out" data-aos-delay={100}>
              <img src="/assets/img/ship-1.png" className="img-fluid animated" alt="" style={{ height: '350px' }} />
            </div>
            <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-in">
              <h1>Let’s hire your next great candidate. Fast.</h1>
              <p>No matter the skills, experience or qualifications you’re looking for, you’ll find the right people here.</p>
              <div className="d-flex">
                <a href={`${process.env.REACT_APP_FRONTEND_PORTAL_URL}/#/verify-email?action=post-a-job`} className="btn-get-started">Post a Job</a>
              </div>
            </div>
          </div>
        </div>

        <svg
          className="hero-waves"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
        >
          <defs>
            <path
              id="wave-path"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>

          <g className="wave1">
            <use href="#wave-path" x="50" y="3" />
          </g>
          <g className="wave2">
            <use href="#wave-path" x="50" y="0" />
          </g>
          <g className="wave3">
            <use href="#wave-path" x="50" y="9" />
          </g>
        </svg>
      </section>
      <main className="main">
        <Outlet />
      </main>
      <Footer />

      <ScrollHandler />
      <ChatWidget />
    </>
  );
}

export default LandingLayout;
